export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12258.aceeef7a.jpg";